module.exports = __webpack_public_path__ + "img/ticketcode.8d507be2.png";